import React, { useEffect } from "react";
import { Badge, Button, FloatButton, Layout, Modal } from "antd";
import classNames from "classnames";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import ScrollToTop from "react-scroll-to-top";

import PayModal from "../pages/Home/Partials/PayModal";
import { ArrowLeftOutlined, ExclamationCircleFilled, FileAddOutlined, MoonFilled, PlusOutlined, ShoppingCartOutlined } from "@ant-design/icons";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import Settings from "./partials/Settings";
import UserMenu from "./partials/UserMenu";
// import smLogoSrc from "../../assets/images/logo-sm.png";
import constants from "../../config/constants";
import { setDarkMode, setOpenPayModal } from "../../redux/app/appSlice";
import { getAllCarts } from "../../redux/cart/cartSlice";
import { getPlans } from "../../redux/plan/planSlice";

const { Header } = Layout;

const stripePromise = loadStripe(constants.stripePK);

function AuthLayout({ children }) {

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const isDarkMode = useSelector(state => state.app.isDarkMode);
  const openPayModal = useSelector(state => state.app.openPayModal);
  const user = useSelector(state => state.auth.user);
  const plans = useSelector(state => state.plan.plans ?? []);
  const cartItems = useSelector(state => state.cart.items);

  useEffect(() => {
    if (plans.length === 0) {
      dispatch(getPlans());
    }
    dispatch(getAllCarts());
  }, [])

  const changeTheme = () => {
    dispatch(setDarkMode());
  }

  const setOpenModal = () => {
    dispatch(setOpenPayModal());
  }

  return (
    <>
      <Layout className="min-h-screen">
        <Header className={classNames("shadow sticky px-0 top-0 z-[999]", !isDarkMode && "bg-white")}>
          <div className="flex justify-between items-center mx-auto px-2 max-w-7xl">
            <div className={classNames("demo-logo h-[64px] mb-2", !isDarkMode && "bg-white")}>
              <Link to="/home" className="sm:inline hidden">
                <img src={`/imgs/logo${isDarkMode ? '-dark' : ''}.webp`} alt="logo" className="p-3 h-[64px]" />
              </Link>
              <Link to="/home" className="inline sm:hidden">
                <img src="/imgs/logo-sm.png" alt="logo" className="p-3 w-[64px]" />
              </Link>
            </div>
            <div className="flex items-center">
              <div>
                <Link to="/my-restorations" className="mr-2 sm:mr-6">
                  My Restoration
                </Link>
              </div>
              <div>
                <Link to="/carts" className="mr-3 sm:mr-8">
                  <Badge count={cartItems.length} offset={[8, 0]}>
                    <ShoppingCartOutlined className="text-lg" />
                  </Badge>
                </Link>
              </div>
              {/* <div className="mr-2 sm:mr-6">
                <Button type="primary" icon={<FileAddOutlined />} onClick={() => {
                  // return navigate('/home');
                  if (user.activeSubscription && user.activeSubscription.status == 'active') {
                    return navigate('/home');
                  }
                  if (user.activeSubscription && user.activeSubscription.status != 'active') {
                    Modal.confirm({
                      title: 'Your subscription past due.',
                      icon: <ExclamationCircleFilled />,
                      content: 'Will you continue it?',
                      okText: "Yes",
                      cancelText: "No",
                      onOk() {
                        window.open(user.activeSubscription.hosted_invoice, '_blank');
                        return new Promise((resolve, reject) => {
                          setTimeout(resolve, 1000);
                        }).catch(() => console.log('Oops errors!'));
                      },
                      onCancel() {
                        console.log('Cancel');
                      },
                    });
                  } else {
                    setOpenModal();
                  }
                }}>New Project</Button>
              </div> */}
              <UserMenu />
            </div>
          </div>
        </Header>
        {/* <div onClick={() => {
          navigate(-1);
        }} className={classNames("sticky w-[75px] cursor-pointer top-20 -ml-11 hover:ml-0 ease-in-out transition-[margin] z-[998] px-2.5 py-2 rounded-e-3xl", isDarkMode ? "bg-gray-100" : "bg-gray-300")}>
          <span>Back</span> &nbsp; <ArrowLeftOutlined />
        </div> */}
        <Layout /* className="h-[1000px]" */>
          {children}
        </Layout>
        {/* <ScrollToTop smooth className="animate-bounce" /> */}
        {/* <FloatButton.BackTop /> */}
        <Settings />
        <Elements stripe={stripePromise} nonce="random-nonce">
          <PayModal
            open={openPayModal}
            setOpen={setOpenModal}
            price={plans[0]?.price}
            planId={plans[0]?._id}
            setSuccessful={() => { }}
          />
        </Elements>
      </Layout>
    </>
  );
}

export default AuthLayout;
